import { render } from "./PrescriptionDetailsMobileBox1.vue?vue&type=template&id=1cc22bbc"
import script from "./PrescriptionDetailsMobileBox1.vue?vue&type=script&lang=js"
export * from "./PrescriptionDetailsMobileBox1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__